export const KEY_PUT_CONTENTS_RATING = 'put.contents-rating.call';
